import React, { InputHTMLAttributes } from 'react';
import Input from './Input';
import { ReactComponent as SearchIcon } from 'assets/icons/icon-search.svg';

const SearchInput = (
  props: InputHTMLAttributes<HTMLInputElement> & { onResetClick?: () => void },
) => {
  return (
    <Input
      {...props}
      autoComplete="off"
      spellCheck="false"
      inputClasses="bg-white border my-0 text-sm"
      icon={<SearchIcon className="absolute w-4 h-4 ml-3 text-gray-500" />}
    />
  );
};

export default SearchInput;
